import { useMemo } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { OwnerType } from "@/domains/inventory/constants/ownerType";
import { inventoryMapSelector, tradeSelector } from "@/domains/inventory/slice";
import { playerInfoSelector } from "@/domains/player/slice";
import { sortInventories } from "@/domains/inventory/helpers/sortedInventories";
import InventoryDndContextWrapperContainer from "@/domains/inventory/containers/InventoryDndContextWrapperContainer";
import InventoryTradeBagContainer from "@/domains/inventory/containers/trade/InventoryTradeBagContainer";
import InventoryTradeExchangeContainer from "@/domains/inventory/containers/trade/InventoryTradeExchangeContainer";
import InventoryTradeOtherSuggestionContainer from "@/domains/inventory/containers/trade/InventoryTradeOtherSuggestionContainer";
import InventoryTradeSelfSuggestionContainer from "@/domains/inventory/containers/trade/InventoryTradeSelfSuggestionContainer";

type Props = {
  isOpen: boolean;
};

export default function TradeContainer({ isOpen }: Props) {
  const playerInfo = useAppSelector(playerInfoSelector);
  const trade = useAppSelector(tradeSelector);
  const inventoryMap = useAppSelector(inventoryMapSelector);

  const sortedInventories = useMemo(() => sortInventories(inventoryMap), [inventoryMap]);

  if (!isOpen || !trade || !playerInfo) return null;

  return (
    <InventoryDndContextWrapperContainer>
      <div className="fixed inset-0 px-[--boundary-offset-x] py-[--boundary-offset-y] flex items-end justify-end gap-5 z-[9999]">
        <InventoryTradeOtherSuggestionContainer currCharacterId={playerInfo.character.id} />
        <InventoryTradeSelfSuggestionContainer currCharacterId={playerInfo.character.id} />
        {sortedInventories.map(([key, inventory]) => {
          switch (inventory.ownerType) {
            case OwnerType.Character:
              return (
                <InventoryTradeExchangeContainer
                  key={key}
                  currCharacterId={playerInfo.character.id}
                  inventoryId={inventory.id}
                />
              );
            case OwnerType.Bag:
              return <InventoryTradeBagContainer key={key} inventoryId={inventory.id} />;
            default:
              return null;
          }
        })}
      </div>
    </InventoryDndContextWrapperContainer>
  );
}
